import styled from 'styled-components';

interface VisuallyHiddenProps {
  hasException?: boolean;
  children: React.ReactNode;
}

export const VisuallyHidden: React.FC<VisuallyHiddenProps> = (props) => {
  const { hasException, children } = props;

  return !hasException ? (
    <VisuallyHiddenWrapper>{children}</VisuallyHiddenWrapper>
  ) : (
    <>{children}</>
  );
};

const VisuallyHiddenWrapper = styled.span`
  visibility: hidden;
`;
